export const arrayActions = {
    UPDATE: 'UPDATE',
    ADD_BOX: 'ADD_BOX', // Add new index to array
    POP_BOX: 'POP_BOX', // Remove an index from array
}

export const UPDATE_SEARCH = 'UPDATE_SEARCH'
export const CHANGE_TAB = 'CHANGE_TAB'
